<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';
import { RecycleScroller } from 'vue-virtual-scroller';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'delete']);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
</script>

<template>
  <RecycleScroller
    v-if="campaigns.length > 30"
    :items="campaigns"
    key-field="id"
    class="flex flex-col gap-4"
    :item-size="112"
  >
    <template #default="{ item: campaign }">
      <CampaignCard
        :title="campaign.title"
        :message="campaign.message"
        :audience="campaign.audience"
        :is-enabled="campaign.enabled"
        :status="campaign.campaign_status"
        :sender="campaign.sender"
        :inbox="campaign.inbox"
        :scheduled-at="campaign.scheduled_at"
        :error="campaign.error"
        :sent="campaign.it_sent"
        :failed="campaign.failed"
        :processed="campaign.status_send"
        :is-live-chat-type="isLiveChatType"
        @edit="handleEdit(campaign)"
        @delete="handleDelete(campaign)"
      />
    </template>
  </RecycleScroller>
  <div v-else class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :audience="campaign.audience"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :error="campaign.error"
      :sent="campaign.it_sent"
      :failed="campaign.failed"
      :processed="campaign.status_send"
      :is-live-chat-type="isLiveChatType"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
    />
  </div>
</template>
